/* jshint esversion: 8 */
define([
  "underscore",
  "jquery",
  "pages/abstractPage",
  "templates/aboutPage",
  "templates/aboutPageReleaseInfoRow",
  "dojo/i18n!nls/cloudCenterStringResource",
  "dojo/string",
  "util",
  "config",
  "service/cachedDataService",
  "service/datatransform/ruleInfo",
  "releaseInfo"
], function( _, $, AbstractPage, PageTemplate, RowTemplate,
             I18NStringResource, DojoString, Util, Config, CachedDataService,
             RuleInfo, ReleaseInfo
) {

  class AboutPage extends AbstractPage {
    constructor(params) {
      super(params);
      this.localDataService = this.getDataService();
      this.pageTemplate = PageTemplate;
      this.rowTemplate = RowTemplate;
      this.applyReleaseDataFilter = true;
      this.events = {
        'click div#aboutPageView > div.facetBar > ul.facets > li > a#resourceLink': 'goToResource',
        'click div#aboutPageView > div.facetBar > ul.facets > li > a#credentialLink': 'goToCredential',
        'click button.btn.btn-link.default-link.AboutPage': 'goToHome',
        'click div#aboutPageView button.warning-notification': 'handleEolWarning'
      };
      // bind 'this' in the listed methods to the current 'this', even when called by other modules.
      _.bindAll(this, 'logoutPage', 'goToAbout', 'getAuthManager', 'goToHome', 'goToCredential', 'goToResource');
    }

    getLocalDataService() {
      return this.localDataService;
    }

    applyReleaseFilter() {
      return this.applyReleaseDataFilter;
    }

    goToAbout() {
      /* do nothing */
    }

    startPage(msgHandler) {
      super.startPage();
      if (!msgHandler || typeof msgHandler !== 'function') {
        throw new TypeError('Invalid message handler argument');
      }
    }

    stopPage() {
      super.stopPage();
    }

    handleEolWarning(event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
        const data = event.currentTarget.dataset;
        const monthAndYear = data.sunsetdate;
        if (data) {
          let msg = '';
          if (data.status == RuleInfo.StatusIntDeprecated) {
            msg = `${data.release}: ${DojoString.substitute(I18NStringResource.releaseIsDeprecated, [monthAndYear])}`;
          }
          if (data.status == RuleInfo.StatusIntSunsetted) {
            msg = `${data.release}: ${DojoString.substitute(I18NStringResource.releaseIsSunsetted, [monthAndYear])}`;
          }
          if (msg) {
            Util.notify('WARNING', msg);
          }
        }
      }
    }

    async getReleaseData() {
      const uniqueReleases = {};
      try {
        const availableTypes = await this.getLocalDataService().getWorkflowService().listAvailable();
        if (Array.isArray(availableTypes)) {
          for (const entry of availableTypes) {
            const id = `${entry.product} ${entry.version}`;
            const product = entry.product;
            if (!uniqueReleases[product]) {
              uniqueReleases[product] = {};
            }
            if (uniqueReleases[product][id]) {
              uniqueReleases[product][id].add(entry.cloud_provider, entry.operating_system);
            } else {
              uniqueReleases[product][id] = ReleaseInfo.fromAvailableType(entry);
            }
          }
        }
      } catch (error) {
        Util.consoleLogError(error);
      }
      return uniqueReleases;
    }

    releaseDataIsValid(releaseData) {
      if (!this.applyReleaseFilter()) {
        return true;
      }
      let isValid = false;
      if (typeof releaseData === 'object' && typeof releaseData.release === 'string' && typeof releaseData.providers === 'object') {
        const releaseRegExp = /^R(\d{4})(a|b)$/;
        if (releaseData.release.match(releaseRegExp) && releaseData.providers && Object.keys(releaseData.providers).length) {
          isValid = true;
        }
      }
      return isValid;
    }

    appendReleaseData(uniqueReleases) {
      const table2 = this.el.querySelector('ol#tandcList2');
      const productNameList = Object.keys(uniqueReleases).sort();
      if (table2) {
        for (const p of productNameList) {
          const releaseKeys = Object.keys(uniqueReleases[p]).sort().reverse();
          for (const key of releaseKeys) {
            const releaseData = uniqueReleases[p][key];
            let ssd = Util.extractMonthYearString(releaseData.sunsetOnDate);
            if (ssd) {
              releaseData.sunsetOnDate = ssd;
            }
            if (this.releaseDataIsValid(releaseData)) {
              const rowHtml = this.rowTemplate({ i18n: I18NStringResource, DojoString: DojoString, data: releaseData });
              const row = $(rowHtml);
              table2.appendChild(row[0]);
            }
          }
        }
      }
    }

    async render() {
      this.getLocalDataService().clearAll();
      const touchevents = Util.touchEventsEnabled();
      const supportedCPs = Config.getSupportedCloudPlatforms();
      const uniqueReleases = await this.getReleaseData();
      const templateHtml = this.generateHTML(supportedCPs);
      this.$el.empty().html(templateHtml);
      this.appendReleaseData(uniqueReleases);
      if (!touchevents) {
        $('[data-bs-toggle="tooltip"]').tooltip();
      }
      this.renderMatrix();
    }

    generateHTML(cps) {
      let azure = false;
      let aws = false;
      for (const cp of cps) {
        switch (cp) {
          case 'azure':
            azure = true;
            break;
          case 'aws':
            aws = true;
            break;
        }
      }
      let templateParams = {
        headerNavigation: this.renderNavigationHeader(),
        i18n: I18NStringResource,
        config: Config,
        azure: azure,
        aws: aws
        // data: products,
      };

      return this.pageTemplate(templateParams);
    }
  }

  return AboutPage;
}); // require
